import React, { Component } from "react";
import Props from "./Props";

class FlexDirection extends Component {
  state = {
    property: "flex-direction",
    definition:
      "The flex-direction CSS property sets how flex items are placed in the flex container defining the main axis and the direction (normal or reversed)",
    defaultOption: "row",
    options: ["row", "row-reverse", "column", "column-reverse"],
    flexContainer: { fcHeight: "450px", fcWidth: "600px" },
    flexItems: [{ label: 1 }, { label: 2 }, { label: 3 }, { label: 4 }],
  };

  render() {
    const { state } = this;

    return <Props {...state} />;
  }
}

export default FlexDirection;
